import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {
  AccountAvailabilityResponse,
  AuthResponse,
  ChangeCredentialsRequest,
  RegisterRequest,
  ValidateRegistrationAccountRequest,
  ValidateRegistrationAccountResponse
} from './auth.model';
import { API_BASE_URL } from '../core/api-base-url';

@Injectable({ providedIn: 'root' })
export class AuthService {
  // Centralized auth API base URL for login, registration, and credential updates.
  private readonly apiBaseUrl = `${API_BASE_URL}/api/auth`;

  constructor(private http: HttpClient) {}

  login(username: string, password: string) {
    // Sends username/password to backend login endpoint.
    return this.http.post<AuthResponse>(`${this.apiBaseUrl}/login`, {
      username,
      password
    });
  }

  register(request: RegisterRequest) {
    return this.http.post<AuthResponse>(`${this.apiBaseUrl}/register`, {
      name: request.name,
      username: request.username,
      email: request.email,
      password: request.password,
      role: request.role,
      mechanicPhone: request.mechanicPhone ?? null,
      mechanicLocation: request.mechanicLocation ?? null
    });
  }

  checkAccountAvailability(username: string, email: string) {
    return this.http.get<AccountAvailabilityResponse>(`${this.apiBaseUrl}/account-availability`, {
      params: {
        username: username.trim(),
        email: email.trim()
      }
    });
  }

  validateRegistrationAccount(request: ValidateRegistrationAccountRequest) {
    // Backend gate for mechanic "Next" step: field validity + DB uniqueness in one check.
    return this.http.post<ValidateRegistrationAccountResponse>(
      `${this.apiBaseUrl}/validate-registration-account`,
      request
    );
  }

  updateCredentials(request: ChangeCredentialsRequest) {
    return this.http.put<AuthResponse>(`${this.apiBaseUrl}/credentials`, {
      name: request.name,
      username: request.username,
      email: request.email,
      password: request.password
    });
  }
}
